export const SET_GOALS = 'SET_GOALS'
export const SAVE_GOAL = 'SAVE_GOAL'
export const DOWNLOADING_GOALS = 'DOWNLOADING_GOALS'
export const SET_SHOW_GOAL_ACTIONS = 'SET_SHOW_GOAL_ACTIONS'
export const SET_SHOW_COMPLETE_GOALS = 'SET_SHOW_COMPLETE_GOALS'
export const UPDATE_GOAL = 'UPDATE_GOAL'
export const RESET_STATE = 'RESET_STATE'

